// extracted by mini-css-extract-plugin
module.exports = {"changePasswordAction":"styles_changePasswordAction__2T0cN","editUserAction":"styles_editUserAction__220wW"};